import React, { useState } from 'react';
import { GlobalKeyframes, PageHeader, SubTabBar, useToasts, ToastStack } from './InventoryUIKit';
import MonthlyInvoice from './MonthlyInvoice';
import CampInvoice from './CampInvoice';
import BagInvoice from './BagInvoice';

const SUBTABS = [
  { id: 'monthly', label: 'Monthly Invoice', icon: '🧾' },
  { id: 'camp', label: 'Camp Invoice', icon: '⛺' },
  { id: 'bag', label: 'Bag Invoice', icon: '🎒' },
];

/**
 * InventoryInvoices
 *
 * Tab: "🧾 Inventory Invoices"
 * Hosts the three invoice subtabs: Monthly Invoice, Camp Invoice, Bag Invoice.
 */
const InventoryInvoices = () => {
  const [activeSubTab, setActiveSubTab] = useState('monthly');
  const { toasts, pushToast, removeToast } = useToasts();

  return (
    <div style={{ fontFamily: "'Inter', sans-serif" }}>
      <GlobalKeyframes />
      <ToastStack toasts={toasts} removeToast={removeToast} />

      <PageHeader
        title="Inventory Invoices"
        description="FIFO-costed invoices for usage, by month, camp, or bag"
      />

      <SubTabBar tabs={SUBTABS} activeTab={activeSubTab} onChange={setActiveSubTab} />

      {activeSubTab === 'monthly' && <MonthlyInvoice pushToast={pushToast} />}
      {activeSubTab === 'camp' && <CampInvoice pushToast={pushToast} />}
      {activeSubTab === 'bag' && <BagInvoice pushToast={pushToast} />}
    </div>
  );
};

export default InventoryInvoices;
